/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BindingDataContractResponseDto } from './BindingDataContractResponseDto';
import {
    BindingDataContractResponseDtoFromJSON,
    BindingDataContractResponseDtoFromJSONTyped,
    BindingDataContractResponseDtoToJSON,
    BindingDataContractResponseDtoToJSONTyped,
} from './BindingDataContractResponseDto';

/**
 * 
 * @export
 * @interface BindingDataResponseDto
 */
export interface BindingDataResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    layerId: string;
    /**
     * 
     * @type {number}
     * @memberof BindingDataResponseDto
     */
    layerNumber: number;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    limitType: BindingDataResponseDtoLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    limit: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    premium: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    totalDeductions: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    binderShareQuoted: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    shareOfLimitQuoted?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    shareOfPremiumQuoted?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    shareOfLimitSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    shareOfPremiumSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof BindingDataResponseDto
     */
    binderShareSigned?: string;
    /**
     * 
     * @type {Array<BindingDataContractResponseDto>}
     * @memberof BindingDataResponseDto
     */
    contracts?: Array<BindingDataContractResponseDto>;
}


/**
 * @export
 */
export const BindingDataResponseDtoLimitTypeEnum = {
    Primary: 'Primary',
    ExcessOfLoss: 'Excess of Loss',
    QuotaShare: 'Quota Share'
} as const;
export type BindingDataResponseDtoLimitTypeEnum = typeof BindingDataResponseDtoLimitTypeEnum[keyof typeof BindingDataResponseDtoLimitTypeEnum];


/**
 * Check if a given object implements the BindingDataResponseDto interface.
 */
export function instanceOfBindingDataResponseDto(value: object): value is BindingDataResponseDto {
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('limitType' in value) || value['limitType'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('premium' in value) || value['premium'] === undefined) return false;
    if (!('totalDeductions' in value) || value['totalDeductions'] === undefined) return false;
    if (!('binderShareQuoted' in value) || value['binderShareQuoted'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function BindingDataResponseDtoFromJSON(json: any): BindingDataResponseDto {
    return BindingDataResponseDtoFromJSONTyped(json, false);
}

export function BindingDataResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BindingDataResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'layerId': json['layerId'],
        'layerNumber': json['layerNumber'],
        'limitType': json['limitType'],
        'limit': json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'premium': json['premium'],
        'totalDeductions': json['totalDeductions'],
        'binderShareQuoted': json['binderShareQuoted'],
        'submissionId': json['submissionId'],
        'shareOfLimitQuoted': json['shareOfLimitQuoted'] == null ? undefined : json['shareOfLimitQuoted'],
        'shareOfPremiumQuoted': json['shareOfPremiumQuoted'] == null ? undefined : json['shareOfPremiumQuoted'],
        'shareOfLimitSigned': json['shareOfLimitSigned'] == null ? undefined : json['shareOfLimitSigned'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'binderShareSigned': json['binderShareSigned'] == null ? undefined : json['binderShareSigned'],
        'contracts': json['contracts'] == null ? undefined : ((json['contracts'] as Array<any>).map(BindingDataContractResponseDtoFromJSON)),
    };
}

export function BindingDataResponseDtoToJSON(json: any): BindingDataResponseDto {
    return BindingDataResponseDtoToJSONTyped(json, false);
}

export function BindingDataResponseDtoToJSONTyped(value?: BindingDataResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layerId': value['layerId'],
        'layerNumber': value['layerNumber'],
        'limitType': value['limitType'],
        'limit': value['limit'],
        'excess': value['excess'],
        'premium': value['premium'],
        'totalDeductions': value['totalDeductions'],
        'binderShareQuoted': value['binderShareQuoted'],
        'submissionId': value['submissionId'],
        'shareOfLimitQuoted': value['shareOfLimitQuoted'],
        'shareOfPremiumQuoted': value['shareOfPremiumQuoted'],
        'shareOfLimitSigned': value['shareOfLimitSigned'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'binderShareSigned': value['binderShareSigned'],
        'contracts': value['contracts'] == null ? undefined : ((value['contracts'] as Array<any>).map(BindingDataContractResponseDtoToJSON)),
    };
}

